module.exports = __webpack_public_path__ + "static/img/15-北京市宣武回民小学.c4231fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/15-北京市宣武回民小学.png
// module id = tOem
// module chunks = 0